import { useLanguage } from "@/contexts/LanguageContext";

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div
      className="py-4 bg-[#223C54]/40 border-b border-white/10 overflow-hidden font-mono-code text-xs text-white/70 uppercase tracking-widest"
      data-testid="marquee-band"
    >
      <div className="mq-track gap-12 items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-12">
            <span>{item}</span>
            <span aria-hidden="true">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
